import type { Testimonial } from '../testimonials'

/**
 * Önder Kaplancık's words, supplied under "Executive quotes" with the Zorlu
 * Holding story on 2026-09-21, together with his portrait.
 *
 * His is the group's voice and takes the mark, so it is this story's Hall of
 * Fame card; Melih Sarıkaya's paragraph is the second tab on the story page
 * (`testimonials/vestel-melih-sarikaya.ts`).
 */
export const added: Testimonial = {
  company: 'Zorlu Holding',
  logo: { name: 'Zorlu Holding', src: '/logo/zorluholdingcard.png' },
  portrait: { src: '/photo/portrait-onder-kaplancik.png', alt: 'Önder Kaplancık' },
  quote: [
    'We wanted an independent view of where we were starting. We now have a consistent way to '
    + 'compare sites and track progress over time.',
  ],
  attribution: 'Önder Kaplancık, General Manager of Technology and AI, Zorlu Holding',
  story: 'zorlu-holding',
}
